var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 193,
    viewBox: "0 0 193 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.267 94.2667C180.267 46.7702 141.763 8.26672 94.2666 8.26672C46.7701 8.26672 8.2666 46.7702 8.2666 94.2667C8.2666 141.763 46.7701 180.267 94.2666 180.267C141.763 180.267 180.267 141.763 180.267 94.2667Z",
    fill: "#00397D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.2696 135.134C96.5978 135.131 98.8749 134.45 100.823 133.174C102.77 131.898 104.304 130.083 105.237 127.95H83.2988C84.2321 130.084 85.7666 131.899 87.7149 133.175C89.6631 134.451 91.9408 135.131 94.2696 135.134Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.009 92.9623V87.7163C119.002 82.4099 117.293 77.2458 114.132 72.9834C110.971 68.721 106.526 65.5853 101.451 64.0377V60.5862C101.451 58.6809 100.694 56.8537 99.3465 55.5064C97.9992 54.1592 96.172 53.4023 94.2667 53.4023C92.3614 53.4023 90.5342 54.1592 89.1869 55.5064C87.8397 56.8537 87.0828 58.6809 87.0828 60.5862V64.0463C82.0069 65.5935 77.5616 68.7291 74.4008 72.9916C71.2401 77.254 69.5308 82.4184 69.5245 87.7249V92.9623C69.542 102.709 65.7741 112.081 59.0153 119.103C58.691 119.442 58.473 119.868 58.3884 120.328C58.3039 120.789 58.3564 121.265 58.5395 121.696C58.7227 122.127 59.0283 122.495 59.4186 122.754C59.809 123.014 60.2668 123.153 60.7353 123.154H127.79C128.258 123.153 128.716 123.014 129.106 122.754C129.496 122.495 129.802 122.127 129.985 121.696C130.168 121.265 130.221 120.789 130.136 120.328C130.052 119.868 129.834 119.442 129.51 119.103C122.754 112.08 118.989 102.708 119.009 92.9623ZM96.6489 63.0888C95.8606 63.0114 95.0608 62.9713 94.2552 62.9713C93.4497 62.9713 92.6499 63.0114 91.8616 63.0888V60.5862C91.8616 59.951 92.1139 59.3418 92.5631 58.8926C93.0123 58.4435 93.6215 58.1911 94.2567 58.1911C94.8919 58.1911 95.5011 58.4435 95.9503 58.8926C96.3994 59.3418 96.6518 59.951 96.6518 60.5862L96.6489 63.0888Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.396 87.722C125.396 88.3572 125.648 88.9664 126.097 89.4156C126.546 89.8648 127.156 90.1171 127.791 90.1171C128.426 90.1171 129.035 89.8648 129.485 89.4156C129.934 88.9664 130.186 88.3572 130.186 87.722C130.199 83.0031 129.276 78.3285 127.47 73.9688C125.664 69.6091 123.011 65.6509 119.665 62.3234C119.216 61.8744 118.607 61.6222 117.973 61.6222C117.338 61.6222 116.729 61.8744 116.28 62.3234C115.831 62.7723 115.579 63.3812 115.579 64.0161C115.579 64.651 115.831 65.2599 116.28 65.7089C119.179 68.5927 121.478 72.0229 123.042 75.801C124.607 79.579 125.407 83.6328 125.396 87.722Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7439 90.1186C61.3787 90.1186 61.9876 89.8664 62.4365 89.4175C62.8854 88.9686 63.1376 88.3597 63.1376 87.7249C63.1264 83.6356 63.9263 79.5848 65.4911 75.8067C67.0558 72.0287 69.3543 68.5985 72.2536 65.7146C72.7025 65.2657 72.9547 64.6568 72.9547 64.0219C72.9547 63.3869 72.7025 62.778 72.2536 62.3291C71.8046 61.8801 71.1957 61.6279 70.5608 61.6279C69.9259 61.6279 69.317 61.8801 68.868 62.3291C65.5229 65.6565 62.8709 69.6144 61.0655 73.9735C59.2601 78.3327 58.3372 83.0067 58.3502 87.7249C58.3502 88.3597 58.6024 88.9686 59.0513 89.4175C59.5002 89.8664 60.1091 90.1186 60.7439 90.1186Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_155",
    x: 0.266602,
    y: 0.266724,
    width: 192,
    height: 192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.325 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_155",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNoti);
export default __webpack_public_path__ + "static/media/empty-noti.7f35071150547e05d162261e4fa2cbcb.svg";
export { ForwardRef as ReactComponent };